import apiRequest from "utils/ApiRequest/apiRequest";

export const fetchIsPickerUser = async (
  id: string | number,
  callback?: (value: boolean) => void
) => {
  const res = await apiRequest(
    "Picker",
    "ExternalPostRequestIsPickerUser",
    {
      UserEncryptedId: id,
    },
    "POST"
  );
  if (res.status === "success") {
    if (callback) {
      callback(res.data);
    } else {
      return res.data;
    }
  } else {
    return null;
  }
};
